module.exports = __webpack_public_path__ + "static/media/prescription.afbce034.svg";